import { NavLink } from "react-router-dom"







export default function AlwaysOptions() {


  return (
    <>
      <NavLink className="link" to="/products">
        products
    </NavLink>
    </>


  )
};
